import {} from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import Navigation from "./Components/Navigation.js";
import FileInput from "./Components/FileInput.js";
import IntegratedAdfitComponent from "./Components/IntegratedAdfitComponent.js";
import ReactGA from "react-ga";
import { useEffect } from "react";

import PageView from "./FailVistorCheck/Query";

function App() {
  useEffect(() => {
    ReactGA.initialize("UA-226193829-1");
    ReactGA.set({ page: window.location.pathname });
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);

  return (
    <>
      <script src="https://cdn.jsdelivr.net/npm/@tensorflow/tfjs@1.3.1/dist/tf.min.js"></script>
      <script src="https://cdn.jsdelivr.net/npm/@teachablemachine/image@0.8.3/dist/teachablemachine-image.min.js"></script>
      <Navigation />
      <h1>AI 무한도전 닮은꼴 테스트</h1>
      <h2>나와 닮은 무한도전 멤버는 누구일까?</h2>
      <PageView />
      <FileInput />
      <IntegratedAdfitComponent />
      <div class="emailHelp">
        <div>
          제작 도움: 🎯
          <a href="https://www.youtube.com/channel/UCQNE2JmbasNYbjGAcuBiRRg">
            조코딩 유튜브
          </a>
        </div>
        <span class="email">문의: gapple71113@gmail.com</span>{" "}
      </div>
      <div class="emailHelp">©All Rights Reserved</div>
    </>
  );
}

export default App;
